import { Component, ElementRef, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { AmChart, AmChartsService } from '@amcharts/amcharts3-angular';
import { ColumnChartService } from './column.service';

@Component({
  selector: 'bidi-column-chart',
  templateUrl: './column.component.html',
  styleUrls: ['./column.component.scss']
})
export class ColumnComponent implements OnInit, OnChanges, OnDestroy {
  private chart: AmChart;
  @ViewChild('chartDiv') private element: ElementRef;
  @Input() private makeChart: Object = {};
  @Input() private chartData: Array<any> = [];
  @Input() private chartMedian: Object = {};
  @Input() chartWith = 100;
  @Input() chartHeight = 255;

  constructor(
    private AmCharts: AmChartsService,
    private chartService: ColumnChartService
  ) {
  }

  ngOnInit() {
    this.chartService.handleDataProvided(this.AmCharts);
    this.chart = this.AmCharts.makeChart(
      this.element.nativeElement,
      this.chartService.makeOptions(this.makeChart, this.chartData)
    );
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.chart && this.chartData.length > 0) {
      this.AmCharts.updateChart(this.chart, () => {
        this.chart.clearLabels();
        this.chart.chartDiv.style.opacity = 1;
        this.chart.dataProvider = this.chartData;
        this.chart.validateData();
      });
    }
  }

  ngOnDestroy() {
    if (this.chart) {
      this.AmCharts.destroyChart(this.chart);
    }
  }
}
